import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { Icon } from "../../generic/icon/Icon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TextLoca } from "../../generic/text/TextLoca";
export var CoopInfoStat = function (_a) {
    var languageIcon = _a.languageIcon, memberCount = _a.memberCount, minLevel = _a.minLevel, memberLimit = _a.memberLimit, playerLevel = _a.playerLevel, isMember = _a.isMember;
    var locaReplacements = new Map([
        [ReplacementLoca.zero_0, utilNumber.format(memberCount)],
        [ReplacementLoca.one_1, utilNumber.format(memberLimit)],
    ]);
    var requiredLevelClassName = isMember
        ? IdStyles.TextBoldSecondaryOutline
        : playerLevel >= minLevel
            ? IdStyles.TextPositive
            : IdStyles.TextNegative;
    var memberCountClassName = isMember
        ? IdStyles.TextBoldSecondaryOutline
        : memberCount < memberLimit
            ? IdStyles.TextPositive
            : IdStyles.TextNegative;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: IdStyles.CoopInfoStatContainer + " flex flex--spaced" },
            React.createElement(TextLoca, { id: IdLoca.coopLanguage_title, className: IdStyles.TextNormal }),
            React.createElement(Icon, { styleId: IdStyles.IconSmall, icon: languageIcon })),
        React.createElement("div", { className: IdStyles.CoopInfoStatContainer + " flex flex--spaced" },
            React.createElement(TextLoca, { id: IdLoca.requiredLevel, className: IdStyles.TextNormal }),
            React.createElement(NumberFormat, { className: requiredLevelClassName, amount: minLevel })),
        React.createElement("div", { className: IdStyles.CoopInfoStatContainer + " flex flex--spaced" },
            React.createElement(TextLoca, { id: IdLoca.members, className: IdStyles.TextNormal }),
            React.createElement(TextLoca, { replacements: locaReplacements, id: IdLoca.value_proportional_value, className: memberCountClassName })),
        React.createElement("div", { className: IdStyles.CoopInfoStatContainer + " flex flex--spaced" },
            React.createElement(TextLoca, { id: IdLoca.status, className: IdStyles.TextNormal }),
            React.createElement(TextLoca, { id: IdLoca.open, className: IdStyles.TextNormal }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/info-view/CoopInfoStat.tsx
// module id = 2609
// module chunks = 3